// Documents
const DocumentList = () => import('@/views/documents/DocumentList.vue')
const DocumentForm = () => import('@/views/documents/DocumentForm.vue')
const DocumentView = () => import('@/views/documents/DocumentView.vue')

export const documentRoutes = [
  {
    path: '/patients/:patientId/documents',
    name: 'PatientDocuments',
    component: DocumentList,
    meta: {
      requireAuth: true,
      title: 'Patient Documents'
    }
  },
  {
    path: '/patients/:patientId/documents/new',
    name: 'NewPatientDocument',
    component: DocumentForm,
    meta: {
      requireAuth: true,
      title: 'New Patient Document'
    }
  },
  {
    path: '/patients/:patientId/documents/:id',
    name: 'ViewPatientDocument',
    component: DocumentView,
    meta: {
      requireAuth: true,
      title: 'View Patient Document'
    }
  },
  {
    path: '/patients/:patientId/documents/:id/edit',
    name: 'EditPatientDocument',
    component: DocumentForm,
    meta: {
      requireAuth: true,
      title: 'Edit Patient Document'
    }
  }
]
